<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import ListagemGenerica from '@/components(new)/UI/Tables/ListagemGenerica/ListagemGenerica.vue'
import FiltroGenerico from '@/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue'
import BaseTable from '@/components(new)/UI/Tables/BaseTable/BaseTable.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import EMPTY_FILTRO_PROCESSO from '@/libs/models/filtro/emptyFiltroProcesso'
import PermissaoHelper from '@/utils/PermissaoHelper.vue'
import AppModalVisualizarCadastro from '@/components(new)/UI/Modals/VisualizacaoCadastro/AppModalVisualizarCadastro.vue'
import VisualizarDocumentos from '@/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue'

export default {
  mixins: [
    AppNotificacao,
    PermissaoHelper
  ],
  components: {
    ListagemGenerica,
    FiltroGenerico,
    BaseTable,
    InputSelect,
    AppModalVisualizarCadastro,
    VisualizarDocumentos
  },
  data () {
    return {
      filtro: EMPTY_FILTRO_PROCESSO('CAIXA_CERTIFICADOS'),
      totalElements: 0,
      totalPages: 0,
      certificados: [],
      municipios: [],
      orgaos: [],
      responsaveis: [],
      sps: [],
      modalVisualizarCadastroIsOpen: false,
      protocolo: null,
      modalVisualizarDocumentoIsOpen: false,
      documentos: [],
      tituloVisualizarDocumento: null
    }
  },
  mounted () {
    this.loadLista()
    this.getMunicipios()
    this.getOrgaos()
    this.getResponsaveis()
    this.getPraticasSustentaveis()
  },
  methods: {
    ...mapActions({
      findByFilter: 'certificado/findByFilter',
      findAllOrgaos: 'pessoa/findAllOrgaos',
      findMunicipiosBySetorLogado: 'municipios/findMunicipiosBySetorLogado',
      findResponsaveisBySetorLogado: 'usuario/findResponsaveisBySetorLogado',
      getSps: 'praticasSustentaveis/getSps',
      getCertificadoView: 'certificado/getDocumentoViewByIdProcesso'
    }),
    async loadLista () {
      const response = await this.findByFilter(this.filtro)
      this.certificados = this.formatarDadosTabela(response.content)
      this.totalElements = response.totalElements
      this.totalPages = response.totalPages
    },
    formatarDadosTabela (dados) {
      return dados.map(dado => ({
        ...dado,
        actions: [
          { key: 'view-process', label: 'Visualizar processo', iconPrefix: 'far', icon: 'eye', action: () => this.viewCadastro(dado.numeroProtocoloCadastro) },
          { key: 'view-certificate', label: 'Visualizar certificado', iconPrefix: 'far', icon: 'file-alt', action: () => this.viewCertificado(dado.idProcesso) }
        ]
      }))
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.loadLista()
    },
    pesquisar (pesquisaSimples) {
      this.filtro.campoSimples = pesquisaSimples
      this.filtro.pagina = 0
      this.loadLista()
    },
    limparPesquisa () {
      this.filtro = EMPTY_FILTRO_PROCESSO('CAIXA_CERTIFICADOS')
      this.loadLista()
    },
    async getMunicipios () {
      const municipios = await this.findMunicipiosBySetorLogado()
      this.municipios = municipios.map(municipio => ({id: municipio.id, nome: municipio.nome}))
    },
    async getOrgaos () {
      const orgaos = await this.findAllOrgaos()
      this.orgaos = orgaos.map(orgao => ({id: orgao, nome: orgao}))
    },
    async getResponsaveis () {
      const responsaveis = await this.findResponsaveisBySetorLogado()
      this.responsaveis = responsaveis.map(responsavel => ({id: responsavel.id, nome: `${responsavel.nomeRazaoSocial} (${responsavel.perfil.nome})`}))
    },
    async getPraticasSustentaveis () {
      const sps = await this.getSps()
      this.sps = sps.map(sp => ({id: sp.codigo, nome: sp.codigo}))
    },
    viewCadastro (protocolo) {
      this.protocolo = protocolo
      this.modalVisualizarCadastroIsOpen = true
    },
    async viewCertificado (idProcesso) {
      this.tituloVisualizarDocumento = 'Certificado'
      this.documentos = [await this.getCertificadoView(idProcesso)]
      this.openModalVisualizarDocumento()
    },
    closeModalVisualizarCadastro () {
      this.modalVisualizarCadastroIsOpen = false
      this.protocolo = null
    },
    async openModalVisualizarDocumento () {
      if (!this.documentos?.length) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Documento não encontrado.')
        return
      }
      this.modalVisualizarDocumentoIsOpen = true
    },
    closeModalVisualizarDocumento () {
      this.modalVisualizarDocumentoIsOpen = false
      this.documentos = []
      this.tituloVisualizarDocumento = null
    }
  }
}
</script>

<template>
  <div class="container">
    <AppModalVisualizarCadastro
      v-if="modalVisualizarCadastroIsOpen"
      :protocolo="protocolo"
      @closeModal="closeModalVisualizarCadastro"
    />
    <VisualizarDocumentos
      v-if="modalVisualizarDocumentoIsOpen"
      @closeModal="closeModalVisualizarDocumento"
      :titulo="tituloVisualizarDocumento"
      :documentos="documentos"
    />
    <div class="content-cadastro">
      <div class="flex-start mt-3 mb-3">
        <FiltroGenerico
          placeholder="Pesquisar por número de processo, nome do proprietário ou CPF/CNPJ"
          widthInput="85%"
          @filtrosPesquisa="pesquisar"
          @limpar="limparPesquisa"
        >
          <template #filtros>
            <InputSelect
              label="Municípios:" v-model="filtro.municipios"
              :multiSelect="true"
              :opcoes="municipios"
            />
            <InputSelect
              label="Tipo de SPS:" v-model="filtro.sps"
              :multiSelect="true"
              :opcoes="sps"
            />
            <InputSelect
              label="Órgão:" v-model="filtro.orgao"
              :opcoes="orgaos"
            />
            <InputSelect
              label="Responsável:" v-model="filtro.responsavel"
              :opcoes="responsaveis"
            />
          </template>
        </FiltroGenerico>
      </div>
      <BaseTable
        title="Listagem"
        :tableData="certificados"
        :columns="[
          { key: 'numeroProcesso', label: 'N° Processo', width: '150rem' },
          { key: 'cpfCnpjProprietario', label: 'CPF/CNPJ', width: '150rem'},
          { key: 'nomeRazaoSocialProprietario', label: 'Proprietário/Razão social' },
          { key: 'municipio', label: 'Município' },
          { key: 'sps', label: 'SPS' },
          { key: 'nomeResponsavel', label: 'Responsável' },
          { key: 'orgao', label: 'Órgão' },
          { key: 'actions', label: 'Ações', align: 'center' }
        ]"
        :pagination="{
          show: true,
          pageSize: filtro.tamanhoPagina,
          totalPages: totalPages,
          totalElements: totalElements
        }"
        @pageChange="changePage"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/analise/certificacao/caixa-certificados/caixa-certificados.vue